import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "min-vh-100" }
const _hoisted_2 = { class: "container d-flex flex-column" }
const _hoisted_3 = { class: "row text-end mt-3" }
const _hoisted_4 = { class: "dropdown" }
const _hoisted_5 = {
  class: "btn btn-outline-secondary dropdown-toggle text-capitalize",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_6 = {
  class: "dropdown-menu",
  style: {"min-width":"0"}
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "row align-items-center justify-content-center" }
const _hoisted_9 = { class: "col-md-6 col-lg-5 col-xl-4 py-6 py-md-0" }
const _hoisted_10 = { class: "mb-4 text-center" }
const _hoisted_11 = { class: "h3 mb-1 text-capitalize-first" }
const _hoisted_12 = {
  key: 0,
  class: "text-muted mb-0"
}
const _hoisted_13 = {
  key: 0,
  method: "post",
  name: "login-form-merchant-p2p"
}
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "form-control-label text-capitalize-first" }
const _hoisted_16 = { class: "input-group input-group-merge" }
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = { class: "form-group mb-0 mt-2" }
const _hoisted_19 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_20 = { class: "form-control-label text-capitalize-first" }
const _hoisted_21 = { class: "" }
const _hoisted_22 = ["placeholder"]
const _hoisted_23 = { class: "form-group mb-0 mt-2" }
const _hoisted_24 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_25 = { class: "form-control-label text-capitalize-first" }
const _hoisted_26 = { class: "" }
const _hoisted_27 = ["placeholder"]
const _hoisted_28 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.lang), 1),
              _createElementVNode("ul", _hoisted_6, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['en', 'ru'], (language) => {
                  return _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      class: "dropdown-item text-capitalize",
                      onClick: _withModifiers(($event: any) => (_ctx.changeLang(language)), ["prevent"]),
                      href: "#"
                    }, _toDisplayString(language), 9, _hoisted_7)
                  ])
                }), 64))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h6", _hoisted_11, _toDisplayString(_ctx.helper.trans('labels.invitation_form_title')), 1),
                  (_ctx.invite)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.helper.trans('labels.invite_set_password')), 1))
                    : _createCommentVNode("", true)
                ]),
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "clearfix" }, null, -1)),
                (_ctx.invite)
                  ? (_openBlock(), _createElementBlock("form", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.helper.trans('labels.login')), 1),
                        _createElementVNode("div", _hoisted_16, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.invite!.user.email) = $event)),
                            readonly: "",
                            class: "form-control form-control-prepend",
                            id: "input-username",
                            name: "username",
                            required: "",
                            placeholder: _ctx.helper.trans('labels.login')
                          }, null, 8, _hoisted_17), [
                            [_vModelText, _ctx.invite!.user.email]
                          ]),
                          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "input-group-prepend" }, [
                            _createElementVNode("span", { class: "" }, [
                              _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "1em",
                                height: "1em",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                class: "feather feather-user"
                              }, [
                                _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
                                _createElementVNode("circle", {
                                  cx: "12",
                                  cy: "7",
                                  r: "4"
                                })
                              ])
                            ])
                          ], -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", null, [
                            _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.helper.trans('labels.password')), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_FormInputWrapper, {
                            errors: _ctx.getErrors(`password`)
                          }, {
                            default: _withCtx((parentProps) => [
                              _withDirectives(_createElementVNode("input", {
                                type: "password",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.request.password) = $event)),
                                class: _normalizeClass(["form-control form-control-prepend", parentProps.class]),
                                id: "input-password",
                                name: "password",
                                placeholder: _ctx.helper.trans('labels.password')
                              }, null, 10, _hoisted_22), [
                                [_vModelText, _ctx.request.password]
                              ])
                            ]),
                            _: 1
                          }, 8, ["errors"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", null, [
                            _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.helper.trans('labels.confirm_password')), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_FormInputWrapper, {
                            errors: _ctx.getErrors(`passwordConfirm`)
                          }, {
                            default: _withCtx((parentProps) => [
                              _withDirectives(_createElementVNode("input", {
                                type: "password",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.request.passwordConfirm) = $event)),
                                class: _normalizeClass(["form-control form-control-prepend", parentProps.class]),
                                id: "input-password",
                                name: "password_confirm",
                                placeholder: _ctx.helper.trans('labels.confirm_password')
                              }, null, 10, _hoisted_27), [
                                [_vModelText, _ctx.request.passwordConfirm]
                              ])
                            ]),
                            _: 1
                          }, 8, ["errors"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("button", {
                          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.save()), ["prevent"])),
                          type: "submit",
                          class: "btn w-100 btn-success text-capitalize-first"
                        }, _toDisplayString(_ctx.helper.trans('button.create_account')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 512))
}